import { sortBy } from "lodash";
import { INVENTORIES_ORDER } from "../constants/shop";
import { Inventory, InventoryStatus } from "@onmo/graphql/graphql";

const getInventoryImage = (inventory?: Inventory) => {
  if (inventory?.data?.__typename === "InventoryBundleData") {
    return inventory?.data.previewUrl;
  } else return inventory?.data.url;
};

const sortAvatars = (avatars?: Inventory[]) => {
  if (!avatars) return;
  const addNewTypeInventory = (inventory: Inventory) => {
    if (inventory.isPurchased) {
      return "shop_Purchased";
    } else if (inventory.status === InventoryStatus.Restricted) {
      return "common_Premium";
    } else if (!inventory?.prices?.length) {
      return "common_Free";
    } else return "shop_Paid";
  };

  const newAvatars = sortBy(
    avatars?.map((avatar) => {
      return {
        ...avatar,
        type: addNewTypeInventory(avatar),
      };
    }),
    (item) => INVENTORIES_ORDER.indexOf(item.type),
  );
  return newAvatars;
};

export const getInventoryTitle = (inventory: Inventory, language: string) => {
  if (!inventory) return "";
  const regionName = new Intl.DisplayNames("en", {
    type: "language",
  });

  let keyTitle = regionName.of(language)?.toLowerCase();
  if (keyTitle === "bangla (bangladesh)") {
    keyTitle = "banglaBangladesh";
  }

  return (
    inventory.metadata?.translations?.[`${keyTitle}Title`] || inventory.title
  );
};

export const Inventories = {
  sortAvatars,
  getInventoryImage,
  getInventoryTitle,
};
